export default "__VITE_ASSET__BedvgvVE__"